<template>

  <footer id="footer">
    <div class="container">

      <div class="row mb-2">

        <div class="col-lg-7 col-sm-12 mt-4 mt-md-0" data-aos="fade-up" data-aos-delay="100">
          <div class="footer-about">
            <div class="image d-flex justify-content-start mb-3" data-aos="fade-right" data-aos-delay="150">
              <a href="/">
                <img src="../assets/img/logo.png" alt="" class="img-fluid" style="width: 180px; margin-left: -5px;">
              </a>
            </div>
            <div class="footer-desc">
              <p>O Sigame Soluções Empresariais atua no mercado contábil há mais de 18 anos, oferecendo soluções multifacetadas e informações estratégicas para orientar as melhores decisões para o seu negócio.</p>
            </div>
            <div class="social-links">
              <!--<a href="#" class="facebook"><i class="bi bi-facebook"></i></a>-->
              <a href="https://www.instagram.com/sigame_solucoesempresariais?igsh=MXM5YmI1ZTkwcGFscQ==" class="instagram"><i class="bi bi-instagram"></i></a>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-md-12 mt-md-0" data-aos="fade-up" data-aos-delay="200">
        </div>

        <div class="col-lg-4 col-md-12 mt-md-0" data-aos="fade-up" data-aos-delay="200">
          <div class="footer-links">
            <!--
            <div class="footer-title mb-4">
              Explore
            </div>
            <div class="mb-3">
              <a href="/termos-de-uso">Termos de uso</a>
            </div>
            <div class="mb-3">
              <a href="/politica-de-privacidade">Política de privacidade</a>
            </div>
            <div class="mb-3">
              <a href="/cidades-atendidas">Cidades Atendidas</a>
            </div>
            -->
          </div>
        </div>
      </div>

      <div class="row mb-2">
        <div class="footer-desc mb-4">
          <p>
            <strong>Sigame Soluções Empresariais Ltda</strong><br>
            CNPJ 08.243.739/0001-36<br>
            CRC/PR - 048934/O-4<br>
            Rua Governador Ney Braga, 5024<br>
            Zona I - Umuarama - Paraná
          </p>
        </div>
      </div>

    </div>

    <div class="footer-final">
      <div class="row d-flex align-items-center" >
        <div class="col-lg-12 text-lg-left text-center">
          <div class="footer-final-copy">
            Sigame &copy;{{ anoAtual }} - Todos os direitos reservados
          </div>
        </div>
      </div>
    </div>

  </footer>

  <a id="whatsapp-button" target="_blank"
    href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20ser%20atendido.">
    <img src="../assets/img/whatsapp-icon.svg" data-lazy-src="../assets/img/whatsapp-icon.svg" data-ll-status="loaded" class="entered lazyloaded">
    <noscript>
      <img src="../assets/img/whatsapp-icon.svg" />
    </noscript>
  </a>

</template>

<script>
export default {
  name: 'FooterComp',
  data () {
    return {
      anoAtual: this.obterAnoAtual()
    }
  },
  methods: {
    obterAnoAtual () {
      const anoAtual = new Date().getFullYear()
      return anoAtual.toString()
    }
  }
}
</script>

<style scoped lang="scss">

#footer {
  background: $bg-base;
  box-shadow: $box-shadow-2;
  padding: 40px 0px 0px 0px;
  color: $color-base;
  font-size: 14px;
}

#footer .footer-links a {
  color: $color-base;
  padding-left: 15px;
  text-decoration: none;
}

#footer .footer-links a:first-child {
  padding-left: 0;
}

#footer .footer-links a:hover {
  color: $a-color;
}

#footer .footer-links {
  font-size: 16px;
  margin: 0 0 10px 0;
  line-height: 1;
  font-weight: 400;
  color: $color-base;
  padding: 5px;
}

#footer .footer-title {
  color: $color-base;
  font-weight: bold;
}

#footer .footer-about {
  font-size: 28px;
  padding: 5px;
}

#footer .footer-about h3 {
  font-size: 16px;
  margin: 0 0 10px 0;
  padding: 0;
  line-height: 1;
  font-weight: 700;
  letter-spacing: 1px;
  color: $color-base;
}

#footer .footer-desc p {
  font-size: 15px;
  color: $color-base;
}

#footer .social-links {
  padding-bottom: 25px;
}

#footer .social-links i {
  font-size: 18px;
  display: inline-block;
  background: $bg-base;
  color: $a-color;
  line-height: 1;
  padding: 10px 0px 0px 0px;
  margin-right: 15px;
  border-radius: 50%;
  text-align: center;
  width: 40px;
  height: 40px;
  transition: 0.3s;
  border: 1px solid $a-color;
}

#footer .social-links i:hover {
  color: $bg-base;
  background: $a-color-hover;
}

#footer .footer-final {
  padding-top: 15px;
  background-color: $a-color;
  color: $bg-base;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0px;
  height: 50px;
}

#footer .footer-final .footer-final-copy {
  color: $bg-base;
}

@media (max-width: 1024px) {
  #footer .footer-desc {
    max-width: 95%;
  }

  #footer .social-links a {
    padding: 8px 0px 0px 0px;
  }

}

@media (max-width: 667px) {
  #footer .footer-about p {
    max-width: 95%;
  }

  #footer .social-links a {
    padding: 8px 0px 0px 0px;
  }

}

/* Icone Whatsapp */
#whatsapp-button {
  display: flex;
  position: fixed;
  background: #25d366;
  z-index: 99999;
  width: 54px;
  height: 54px;
  right: 14px;
  bottom: 16px!important;

  border-radius: 50%;
  box-shadow: 2px 2px 12px rgba(22, 124, 60, .2);
  transition: .4s;
  align-items: center;
  justify-content: center
}

#whatsapp-button>.rwb-tooltip {
  position: absolute;
  bottom: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
  padding: 15px;
  color: #2d2d2d;
  font-size: 16px;
  white-space: nowrap;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, .2);
  opacity: 0;
  transition: .4s;
  pointer-events: none
}

#whatsapp-button>.rwb-tooltip:after {
  display: block;
  content: "";
  position: absolute;
  top: 85%;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 7px 0;
  border-color: #fff transparent transparent transparent;
  transition: .4s
}

#whatsapp-button.left {
  left: 24px
}

#whatsapp-button.left>.rwb-tooltip {
  left: 0;
  transform: translateX(-10%)
}

#whatsapp-button.left>.rwb-tooltip:after {
  left: 23px
}

#whatsapp-button:not(.left)>.rwb-tooltip {
  right: 0;
  transform: translateX(10%)
}

#whatsapp-button:not(.left)>.rwb-tooltip:after {
  right: 23px
}

#whatsapp-button>img {
  display: block;
  width: 34px;
  height: 34px
}

#whatsapp-button:hover {
  background: #21bd5c;
}

#whatsapp-button:hover>.rwb-tooltip {
  opacity: 1;
  transform: translateX(0)
}

#whatsapp-button:hover>.rwb-tooltip:after {
  top: 100%;
  transition-delay: .4s
}

@media (min-width: 480px) {
  #whatsapp-button {
    bottom: 88px;
    width: 60px;
    height: 60px;
    right: 24px;
  }
}
</style>
